import React from "react";
import styles from "./DynamicFilterBar.module.scss";

const DynamicFilterBar = ({
    filterTabs,
    activeTab,
    setActiveTab,
    barType = "default",
}) => {
    const formattedBarType = barType.toLowerCase();

    return (
        <div className={`${styles.filterBar} ${styles[`filterBar-${formattedBarType}`]}`}>
            {filterTabs.map((tab) => (
                <div
                    key={tab.key}
                    className={`${styles.filterTab} ${styles[`filterTab-${formattedBarType}`]} ${activeTab === tab.key ? `${styles.active}` : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    );
};

export default DynamicFilterBar;